export function truncate(text: string, maxLength: number, ellipsis?: boolean): string {
  const doTruncate = text.length > maxLength;
  return text.slice(0, maxLength) + (doTruncate && ellipsis ? '...' : '');
}
